module.exports = __webpack_public_path__ + "img/Emptying_the_skimmer.8bfa650d.png";